<div class="db-hosting">
  <router-outlet></router-outlet>
</div>
